import apiBase from "../../api/axios";

// ============================================================
// FORTALEZA TALENTO USUARIO (Flujo Alumno - Wizard)
// ============================================================

// Iniciar / retomar fortaleza
export const getFortalezaStartService = async () => {
  const response = await apiBase.get(
    "v1/fortalezas/fortaleza-talentos/start/"
  );
  return response.data;
};

// Obtener área actual con sus acciones
export const getFortalezaCurrentService = async () => {
  const response = await apiBase.get(
    "v1/fortalezas/fortaleza-talentos/current/"
  );
  return response.data;
};

// Enviar respuesta (acciones seleccionadas)
// La API envuelve la respuesta en { message, data: {...}, status_code }
export const sendFortalezaAnswerService = async (payload) => {
  const response = await apiBase.post(
    "v1/fortalezas/fortaleza-talentos/answer/",
    payload
  );
  return response.data.data;
};

// Obtener estado
export const getFortalezaStatusService = async () => {
  const response = await apiBase.get(
    "v1/fortalezas/fortaleza-talentos/status/"
  );
  return response.data;
};

// Obtener fortalezas completadas
export const getFortalezasCompletadasService = async () => {
  const response = await apiBase.get(
    "v1/fortalezas/fortaleza-talentos/completed/"
  );
  return response.data;
};

// Obtener resumen de fortalezas
export const getFortalezaSummaryService = async () => {
  const response = await apiBase.get(
    "v1/fortalezas/fortaleza-talentos/summary/"
  );
  return response.data;
};
